var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9945 10.7499L16.8438 9.19443V4.53232C16.8438 3.88779 16.4441 3.31201 15.8383 3.08428L11.5414 1.47295C11.1934 1.33975 10.8066 1.33975 10.4543 1.47295L6.15742 3.08428C5.55156 3.31201 5.15195 3.88779 5.15195 4.53232V9.19443L1.00117 10.7499C0.399609 10.9776 0 11.5534 0 12.1979V16.9288C0 17.5132 0.330859 18.0503 0.855078 18.3124L5.15195 20.4608C5.58594 20.68 6.10156 20.68 6.53555 20.4608L11 18.2265L15.4645 20.4608C15.8984 20.68 16.4141 20.68 16.848 20.4608L21.1449 18.3124C21.6691 18.0503 22 17.5132 22 16.9288V12.1979C22 11.5534 21.6004 10.9776 20.9945 10.7499ZM15.3828 9.22881L11.7305 10.5995V7.66904L15.3828 6.0792V9.22881ZM6.61719 4.47217L11 2.83076L15.3828 4.47217V4.49795L11 6.27686L6.61719 4.49795V4.47217ZM10.2266 16.9804L6.57422 18.8065V15.4077L10.2266 13.7405V16.9804ZM10.2266 12.1679L5.84375 13.9468L1.46094 12.1679V12.1421L5.84375 10.5007L10.2266 12.1421V12.1679ZM20.5391 16.9804L16.8867 18.8065V15.4077L20.5391 13.7405V16.9804ZM20.5391 12.1679L16.1562 13.9468L11.7734 12.1679V12.1421L16.1562 10.5007L20.5391 12.1421V12.1679Z",
    fill: "#FB3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainers);
export default __webpack_public_path__ + "static/media/containers.38cbd4797fb2d8684e9832b067d4aa53.svg";
export { ForwardRef as ReactComponent };